import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import ClientDashboard from './pages/ClientDashboard/ClientDashboard';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Navigation from './components/Navigation/Navigation';
import { useAuth } from './contexts/AuthContext';
import './global.css';
import './pages/ClientDashboard/ClientDashboard.css';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading">
        <div className="app-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Auth Route Component - redirects to dashboard if already authenticated
const AuthRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading">
        <div className="app-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Dashboard Component
const Dashboard = () => {
  const { userRole } = useAuth();
  const [currentPage, setCurrentPage] = useState('overview');

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const renderPage = () => {
    if (userRole === 'admin') {
      return (
        <AdminDashboard onPageChange={handlePageChange} currentPage={currentPage} />
      );
    }

    if (userRole === 'client') {
      return (
        <ClientDashboard onPageChange={handlePageChange} currentPage={currentPage} />
      );
    }

    return (
      <section className="app-placeholder">
        <h2>Unknown Role</h2>
        <p>Your role could not be determined. Please contact support.</p>
      </section>
    );
  };

  return (
    <div className="app dashboard app-shell">
      <Navigation onPageChange={handlePageChange} currentPage={currentPage} />

      <main className="dashboard-content app-main-content">
        {renderPage()}
      </main>
    </div>
  );
};

const App = () => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading">
        <div className="app-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route 
          path="/login" 
          element={
            <AuthRoute>
              <Login />
            </AuthRoute>
          } 
        />
        <Route 
          path="/signup" 
          element={
            <AuthRoute>
              <Signup />
            </AuthRoute>
          } 
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
